import configuration from '../../constants/Configuration';
import FineUploaderS3 from 'fine-uploader-wrappers/s3';
import audioUtils from './AudioUtils';

const fineUploader = {
    uploader: undefined,
    completeCallback: undefined,

    init() {
        var accessKey;
        var bucket;
        var arg = {};
        var acceptedString = "application/vnd.rn-realmedia,application/x-shockwave-flash,audio/m4a,audio/webm,audio/mp3,audio/x-caf,audio/caf,audio/mpeg,audio/mpg,audio/ogg,audio/wav,audio/x-m4a,audio/x-mp3,audio/x-wav, audio/vnd.wave,image/bmp,image/gif,image/jpeg,image/jpeg,image/pjpeg,image/pjpeg,image/png,image/tif,image/tiff,image/x-bmp,image/x-citrix-pjpeg,image/x-png,image/x-tif,image/x-tiff,image/x-windows-bmp,sound/mpeg,video/3g2,video/3gp,video/3gpp,video/MP2T,video/MP2T_m2ts,video/avi,video/divx,video/mp4,video/mpeg,video/mpeg_mod,video/mpg,video/ogg,video/quicktime,video/webm,video/x-dv,video/x-flv,video/x-m4v,video/x-ms-wmv,video/x-msvideo,";

        arg.options = {};
        if (configuration.IS_PROD() == true) {
            accessKey = 'AKIAJYMW5PW6FZLDMV2Q';
            bucket = 'creaza-upload';
        } else {
            accessKey = 'AKIAJW24ZO65AI7KR7BA';
            bucket = 'creaza-stage-upload';
        }

        arg.options.autoUpload = true;
        arg.options.request = {endpoint: 'https://s3-eu-west-1.amazonaws.com/' + bucket, accessKey: accessKey, clockDrift: audioUtils.serverTimeOffset};
        arg.options.signature = {endpoint: '/ICSXapi/file/SignS3Policy'};
        arg.options.validation = {acceptFiles: acceptedString};
        arg.options.uploadSuccess = {endpoint: '/ICSXapi/file/StoreUploadedRecording'};

        this.uploader = new FineUploaderS3(arg);
        this.uploader.on('complete', this.onComplete.bind(this));
        this.uploader.on('error', this.onFail.bind(this));
    },
    onComplete(var1, var2, var3) {
        if (this.completeCallback)
            this.completeCallback(var1, var2, var3);
    },
    onFail() {
    },
    uploadFile(blob, title, completeHandler) {
        this.completeCallback = completeHandler;

        var blobWrapper = {blob: blob, name: title};
        this.uploader.methods.addFiles([blobWrapper]);
    }
};

export default fineUploader;



/** WEBPACK FOOTER **
 ** ./src/components/utils/FineUploader.js
 **/